<template>
  <div class="flex flex-col">
    <!-- label for the input -->
    <label
      v-show="label"
      :for="`r-select-${_uid}`"
      class="text-sm font-semibold"
    >
      {{ label }}
    </label>
    <!-- input -->
    <div class="relative">
      <select
        :id="`r-select-${_uid}`"
        :value="value"
        :placeholder="placeholder"
        @change="onSelectChange"
        class="block appearance-none px-2 py-2 w-full border rounded border-gray-400 outline-none focus:border-r-primary"
      >
        <option v-for="(option, i) in options" :key="i" :value="option.value">
          {{ option.display }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Define the text field component
 */
export default {
  // set the component name
  name: "r-select",

  // external props
  props: {
    // the content of the label
    label: {
      type: String,
      default: ""
    },

    // the placeholder
    placeholder: {
      type: String,
      default: ""
    },

    // the value of the text field
    value: {
      type: String,
      default: ""
    },

    // options
    options: {
      type: Array,
      default: () => []
    }
  },

  // methods
  methods: {
    onSelectChange(e) {
      this.$emit("input", e.target.value)
    }
  }
}
</script>
